import {termsOfUse} from "../../data/termsOfUse";
import LegalAccordion from "../../components/LegalAccordion";
import "./TermsOfUsePage.css";


const TermsOfUsePage = () => {

    return (

        <section className="terms-page">

            <div className="terms-hero">

                <span>
                    Legal
                </span>

                <h1>
                    Terms of Use
                </h1>


                <p>
                    These terms explain your rights and responsibilities
                    when using Magyne services.
                </p>


                <div className="effective-date">

                    Effective Date: 01 June, 2026

                </div>


            </div>


            <div className="terms-container">


                {termsOfUse.map(section => (

                    <LegalAccordion
                        key={section.id}
                        section={section}
                    />

                ))}


            </div>


        </section>

    );

};


export default TermsOfUsePage;